import * as yup from "yup";
import { PHONE_ERROR_MESSAGE } from "../messages";

export const unsubscribeSchema = yup.object().shape({
  phone: yup
    .string()
    .required(PHONE_ERROR_MESSAGE)
    .min(11, PHONE_ERROR_MESSAGE),
});
